import { getLegend } from "../tools";

// const Aecharts = () => import('@/components/Aecharts');

const Aecharts = a => require(['@/components/Aecharts'], a);

export default {
  name: 'DePie',
  props: {
    data: {
      type: Array,
      default: () => [
        { name: '', value: '0', color: '#fe4ecd' },
      ]
    },
    title: { type: String, default: () => '标题' },
    name: { type: String, default: () => '' },
    colors: { type: Array, default: () => ['#fe4ecd', '#2697ff', '#4fffff', '#892bfe'] },
    type: { type: String, default: () => 'pie' },
    radius: { type: Array, default: () => ['35%', '55%'] },
    roseType: { type: String, default: () => '' },
    showLegend: { type: Boolean, default: () => false },
    delay: { type: Number, default: () => 100 },
    backgroundColor: { type: String, default: () => '' },
  },
  data() {
    return {
      option: {},
    }
  },
  watch: {
    data(next, prev) {
      if (JSON.stringify(next) != JSON.stringify(prev)) this.create();
    }
  },
  created() {
    this.create();
  },
  methods: {
    create() {
      let series = [
        {
          name: this.title,
          type: this.type,
          radius: this.radius,
          roseType: this.roseType,
          center: ['50%', '40%'], // 位置调整
          data: this.data.length > 0 && this.data.map((a, b) => ({
            selected: false,
            label: {
              show: false,
            },
            labelLine: {
              lineStyle: {
                color: 'rgba(255, 255, 255, 0)'
              },
              smooth: 0.2,
              length: 10,
              length2: 10,
            },
            itemStyle: {
              normal: {
                color: a.color ? a.color : this.colors[b],
                shadowBlur: 200,
                shadowColor: 'rgba(0, 0, 0, 0.4)',
                shadowOffsetX: -4,
                shadowOffsetY: 4,
              },
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              }
            },
            animationDelay: c => c * b * 100,
            ...a,
          })).sort((a, b) => (a.value - b.value)),
          animationType: 'expansion',
          animationEasing: 'elasticOut',
          animationDelay: (idx) => idx * 200,
        },
      ];
      this.option = {
        backgroundColor: this.backgroundColor,
        tooltip: {
          trigger: 'item',
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        grid: {
          show: false,
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          containLabel: false,
        },
        legend: {
          orient: 'horizontal',
          x: 'center',
          y: 'bottom',
          itemWidth: 12,
          itemHeight: 12,
          itemStyle: {
            borderType: '',
          },
          borderRadius: 0,
          itemGap: 8,
          textStyle: {
            color: '#fff'
          },
          data: this.data.map(a => a.name),
        },
        calculable: true,
        series,
      };
    },
  },
  render() {
    return <Aecharts option={this.option} delay={this.delay} />
  }
}